import { ChangeDetectorRef, computed, input } from '@angular/core';
import { CrudManagerService } from '../crud-manager';
import { CrudTemplate } from '../crud-templates.interface';
import { DynamicComponentDirective, DynamicComponentIOCheck, TruncatePipe } from '@core/frontend-shared';
import { FormsModule } from '@angular/forms';
import { UiInputSwitchComponent } from '@common/ui/frontend-shared/input-switch';
import { UiIconComponent } from '@common/ui/frontend-shared/icons';
import { UiSpinnerComponent } from '@common/ui/frontend-shared/spinner';
import * as i0 from "@angular/core";
import * as i1 from "../crud-manager";
import * as i2 from "@angular/forms";
const _c0 = ["crud-list-item", ""];
const _c1 = () => ["", ""];
const _c2 = () => ["deaktiviert", "aktiviert"];
function CrudListItemComponent_Conditional_0_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CrudListItemComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CrudListItemComponent_Conditional_0_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("dynamicComponent", ctx_r0.listItemComponentConfig);
  }
}
function CrudListItemComponent_Conditional_0_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("icon", ctx_r0.itemInfo().icon);
  }
}
function CrudListItemComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, CrudListItemComponent_Conditional_0_Conditional_2_Conditional_0_Template, 1, 1, "ui-icon", 4);
    i0.ɵɵelementStart(1, "h4", 5);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "truncate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    let tmp_4_0;
    const itemUnwrapped_r2 = i0.ɵɵnextContext();
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(((tmp_3_0 = ctx_r0.itemInfo()) == null ? null : tmp_3_0.icon) ? 0 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 2, ((tmp_4_0 = ctx_r0.itemInfo()) == null ? null : tmp_4_0.name) || itemUnwrapped_r2.name, 50));
  }
}
function CrudListItemComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "ui-input-switch", 6);
    i0.ɵɵlistener("ngModelChange", function CrudListItemComponent_Conditional_0_Conditional_3_Template_ui_input_switch_ngModelChange_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const itemUnwrapped_r2 = i0.ɵɵnextContext();
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.toggleItem(itemUnwrapped_r2));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const itemUnwrapped_r2 = i0.ɵɵnextContext();
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngModel", itemUnwrapped_r2.enabled)("disabled", ctx_r0.restraints.canToggle !== true)("labels", ctx_r0.layout === "compact" ? i0.ɵɵpureFunction0(3, _c1) : i0.ɵɵpureFunction0(4, _c2));
  }
}
function CrudListItemComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵconditionalCreate(1, CrudListItemComponent_Conditional_0_Conditional_1_Template, 1, 1, "ng-container")(2, CrudListItemComponent_Conditional_0_Conditional_2_Template, 4, 5);
    i0.ɵɵconditionalCreate(3, CrudListItemComponent_Conditional_0_Conditional_3_Template, 2, 5, "div", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.listItemComponentConfig ? 1 : 2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.crudManager.enableToggle ? 3 : -1);
  }
}
function CrudListItemComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "ui-spinner", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("size", 20)("margin", false);
  }
}
export let CrudListItemComponent = /*#__PURE__*/(() => {
  class CrudListItemComponent {
    set _layout(l) {
      this.setLayout(l);
    }
    constructor(cd, crudManager) {
      this.cd = cd;
      this.crudManager = crudManager;
      this.listItemComponentConfig = null;
      this.enableContextMenu = false;
      this.layout = 'default';
      this.compact = false;
      this.loadingDependencies = false;
      this.dependencies = null;
      this.item = input(...(ngDevMode ? [undefined, {
        debugName: "item"
      }] : /* istanbul ignore next */[]));
      this.loadingState = input(...(ngDevMode ? [undefined, {
        debugName: "loadingState"
      }] : /* istanbul ignore next */[]));
      this.isLoading = computed(() => {
        const item = this.item();
        const loadingState = this.loadingState();
        const isLoading = !item || loadingState.anyLoading && loadingState.ids && loadingState.ids.includes(item.id);
        return isLoading;
      }, ...(ngDevMode ? [{
        debugName: "isLoading"
      }] : /* istanbul ignore next */[]));
      this.itemInfo = input(null, ...(ngDevMode ? [{
        debugName: "itemInfo"
      }] : /* istanbul ignore next */[]));
    }
    ngOnInit() {
      if (!this.item()) throw new Error('CrudTableItem error: Required Input is missing!');
      this.restraints = this.crudManager.getItemRestraintsInfo(this.item());
      if (this.crudManager.templates[CrudTemplate.ListItem]) this.setupListItemTemplate();
    }
    setLayout(layout) {
      this.layout = layout;
      this.compact = layout === 'compact';
      this.cd.markForCheck();
    }
    setupListItemTemplate() {
      this.listItemComponentConfig = {
        component: this.crudManager.templates[CrudTemplate.ListItem],
        inputs: {
          restraints: this.restraints,
          item: this.item()
        },
        // template component has only the inputs that it needs, disable erroring in case of missing IOs
        IOCheck: DynamicComponentIOCheck.FilterUnknown
      };
    }
    toggleItem(e) {
      this.executeItemAction('toggle', e);
    }
    deleteItem(e) {
      this.executeItemAction('delete', e);
    }
    executeItemAction(action, event) {
      if (event?.stopPropagation) event.stopPropagation();
      this.crudManager.executeItemAction(this.item(), action);
    }
    functionRequiresDependencies(func) {
      return func.length > 1;
    }
    static {
      this.ɵfac = function CrudListItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CrudListItemComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.CrudManagerService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CrudListItemComponent,
        selectors: [["", "crud-list-item", ""]],
        hostVars: 2,
        hostBindings: function CrudListItemComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("compact", ctx.compact);
          }
        },
        inputs: {
          enableContextMenu: "enableContextMenu",
          _layout: [0, "layout", "_layout"],
          loadingDependencies: "loadingDependencies",
          dependencies: "dependencies",
          item: [1, "item"],
          loadingState: [1, "loadingState"],
          itemInfo: [1, "itemInfo"]
        },
        attrs: _c0,
        decls: 2,
        vars: 2,
        consts: [[1, "ui-clearfix", "crud-list-item-content"], [1, "loading"], [1, "item-state"], [4, "dynamicComponent"], [1, "list-item-icon", 3, "icon"], [1, "name"], ["size", "small", 3, "ngModelChange", "ngModel", "disabled", "labels"], [3, "size", "margin"]],
        template: function CrudListItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, CrudListItemComponent_Conditional_0_Template, 4, 2, "div", 0);
            i0.ɵɵconditionalCreate(1, CrudListItemComponent_Conditional_1_Template, 2, 2, "div", 1);
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵconditional((tmp_0_0 = ctx.item()) ? 0 : -1, tmp_0_0);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isLoading() ? 1 : -1);
          }
        },
        dependencies: [DynamicComponentDirective, UiIconComponent, UiInputSwitchComponent, FormsModule, i2.NgControlStatus, i2.NgModel, UiSpinnerComponent, TruncatePipe],
        styles: ["[_nghost-%COMP%]:not(.compact){min-height:50px}[_nghost-%COMP%]{display:flex;align-items:center}.loading[_ngcontent-%COMP%]{background-color:var(--contentSoftColor)!important;position:absolute;inset:0}.loading[_ngcontent-%COMP%]{display:flex;z-index:5;align-items:center;justify-content:center}.name[_ngcontent-%COMP%]{margin:0 0 5px;font-size:.85rem}.type[_ngcontent-%COMP%]{margin:0}.item-state[_ngcontent-%COMP%]{margin-top:5px}.compact[_nghost-%COMP%]   .item-state[_ngcontent-%COMP%]{margin-top:5px;position:absolute;right:0;top:0}.crud-list-item-content[_ngcontent-%COMP%]{width:100%}.list-item-icon[_ngcontent-%COMP%]{position:absolute;right:6px;top:6px;color:var(--greyColor)}\n\n/*# sourceMappingURL=crud-list-item.component.ts-angular-inline--76.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return CrudListItemComponent;
})();